import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-closet-desk-a-per',
  templateUrl: './closet-desk-a-per.component.html',
  styleUrls: ['./closet-desk-a-per.component.css']
})
export class ClosetDeskAPerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
